<cc-box>
  <div box header
       class="header"
  >
    <div>
      <img [src]="iconSrc" class="icon">
      <span>{{provider}}</span>
    </div>

    <button *ngIf="!expanded" (click)="expand()" class="arrow-button">
      <i class="material-icons arrow-icon">keyboard_arrow_down</i>
    </button>
    <button *ngIf="expanded" (click)="collapse()" class="arrow-button">
      <i class="material-icons arrow-icon">keyboard_arrow_up</i>
    </button>
  </div>

  <div box content class="content" [class.visible]="expanded">

    <div [innerHTML]="'FIRST_STEPS.WEB_CALL.INSTALLATION.' + translateKey + '.STEPS' | translate"></div>

    <div ace-editor
         [text]="codeToInstall"
         mode="html"
         theme="dawn"
         [options]="{printMargin: false, highlightActiveLine: false, useWorker: false}"
         [readOnly]="true"
         class="editor"
    >
    </div>

    <div class="button-wrapper">
    <button
      mat-button
      mat-raised-button
      ngxClipboard
      [cbContent]="codeToInstall"
      color="info-full">
      {{'LEAD_GENERATION.INSTALLATION.COPY' | translate}}
    </button>
    </div>
  </div>

</cc-box>
